import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Details } from '@cc-shopping/ui/primitives/Details';
import { palette } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
const ACCORDION_BORDER_RADIUS = '16px';
export type AskOurExpertsMobileProps = {
  question?: string | null;
  experts: {
    name: string;
    avatarUrl?: string | null;
  }[];
  renderedContents: ReactNode[];
};
export function AskOurExpertsMobile(t0) {
  const $ = _c(10);
  const {
    question,
    experts,
    renderedContents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      sm: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== experts || $[2] !== question || $[3] !== renderedContents) {
    let t3;
    if ($[5] !== question || $[6] !== renderedContents) {
      t3 = (expert, index) => <Details key={`accordion-item-${expert.name}`} variant="simple" SummaryComponent={<Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px"
      }}><Box display="flex" alignItems="center">{expert.avatarUrl && <CdnImage width={48} height={48} style={{
            marginRight: "16px",
            borderRadius: "50%"
          }} src={expert.avatarUrl} alt={`${expert.name} avatar`} />}<Typography variant="smallHeadline" sx={{
            alignItems: "center"
          }}>{expert.name}</Typography></Box><span className="mask-icon mask-icon-expand-more expand-icon" style={{
          width: "24px",
          height: "24px",
          backgroundColor: palette.common.black
        }} /></Box>} summaryComponentProps={{
        sx: {
          paddingX: 3
        },
        id: `panel-header-${expert.name}`
      }} detailsProps={{
        open: index === 0,
        sx: {
          borderTop: "1px solid",
          borderLeft: "1px solid",
          borderRight: "1px solid",
          borderColor: "neutral.lighter",
          "&:first-of-type": {
            borderTopLeftRadius: ACCORDION_BORDER_RADIUS,
            borderTopRightRadius: ACCORDION_BORDER_RADIUS,
            "&> summary:hover": {
              borderTopLeftRadius: ACCORDION_BORDER_RADIUS,
              borderTopRightRadius: ACCORDION_BORDER_RADIUS
            }
          },
          "&:last-of-type": {
            borderBottom: "1px solid",
            borderColor: "neutral.lighter",
            borderBottomLeftRadius: ACCORDION_BORDER_RADIUS,
            borderBottomRightRadius: ACCORDION_BORDER_RADIUS,
            "&> summary:hover": {
              borderBottomLeftRadius: ACCORDION_BORDER_RADIUS,
              borderBottomRightRadius: ACCORDION_BORDER_RADIUS
            }
          },
          "&[open]": {
            "&> summary:hover": {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0
            }
          },
          "&> summary:hover": {
            backgroundColor: "blues.lightest",
            outline: "2px solid",
            outlineColor: "blues.light",
            position: "relative",
            zIndex: 1
          }
        }
      }}><Box sx={{
          padding: 3
        }}>{question && <Typography fontWeight="bold">{question}</Typography>}{renderedContents[index]}</Box></Details>;
      $[5] = question;
      $[6] = renderedContents;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = experts.map(t3);
    $[1] = experts;
    $[2] = question;
    $[3] = renderedContents;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <Box display={t1}>{t2}</Box>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}